<script setup lang="ts">
import { NuxtLink } from '#components';
const { color = 'white' } = defineProps<{
    color: 'white' | 'blue';
}>();

const fontColor = computed(() =>
    color === 'blue' ? 'var(--blue-500)' : color
);
</script>

<template>
    <div class="mrbilit-main-icon-wrapper" aria-label="لوگوی مِستربلیط">
        <NuxtLink class="mrbilit-main-icon-wrapper-link" to="/">
            <div class="icon-container">
                <mr-typography size="display3" weight="700" :color="fontColor">
                    مِستربلیط
                </mr-typography>
                <mr-typography size="x-small" :color="fontColor">
                    بلیط هواپیما و رزرو هتل
                </mr-typography>
            </div>
        </NuxtLink>
    </div>
</template>

<style scoped lang="scss">
.mrbilit-main-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: usePalette();
    }

    .mrbilit-main-icon-wrapper-link {
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
            text-decoration: none;
        }

        .icon-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            white-space: nowrap;
        }
    }
}
</style>
